import { render, staticRenderFns } from "./eventos_descargar.vue?vue&type=template&id=5d4b6b8a"
import script from "./eventos_descargar.vue?vue&type=script&lang=js"
export * from "./eventos_descargar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports